import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

// Три плитки в auto-fit сетке: на узком вьюпорте становятся столбцом сами, без брейкпоинтов.
export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
`;

export const Tile = styled.button`
    display: block;
    width: 100%;
    text-align: left;
    padding: 20px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
    background: ${colors.surface};
    box-shadow: ${shadows.panel};
    cursor: pointer;
    font: inherit;
    transition: border-color 0.15s;

    &:hover {
        border-color: ${colors.primary};
    }

    &:focus-visible {
        outline: 2px solid ${colors.primary};
        outline-offset: 2px;
    }
`;

export const Title = styled.div`
    color: ${colors.textSecondary};
    font-size: 14px;
    margin-bottom: 12px;
`;

export const Value = styled.div`
    font-size: 28px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin-bottom: 12px;
`;

export const Footer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 13px;
    color: ${colors.textSecondary};
`;

const CHANGE_COLORS = {
    up: { color: colors.success, background: "rgba(46,125,50,0.1)" },
    down: { color: colors.danger, background: colors.dangerBg },
    // Изменения нет — и цвета у него нет: нулевой рост, покрашенный в зелёный, читается как рост.
    flat: { color: colors.textSecondary, background: colors.segmentBg },
};

export const Change = styled.span<{ $tone: "up" | "down" | "flat" }>`
    padding: 2px 8px;
    border-radius: ${radii.small};
    font-weight: 600;
    color: ${(props) => CHANGE_COLORS[props.$tone].color};
    background: ${(props) => CHANGE_COLORS[props.$tone].background};
`;

export const Hint = styled.span`
    color: ${colors.textSecondary};
`;
